import React from "react";
import { ReactComponent as LiveMissionsPolygonIcon } from "../../LiveMissionsTable/assets/Polygon.svg";
import { ReactComponent as RectangleIcon } from "../assets/rectangleIcon.svg";
import { TableFieldBodyStyled } from "Components/NewList/styles";
import {
  CounterBodyStyled,
  CounterLoopsStyled,
  CounterStopsStyled,
  DividerLoopsCountersStyled,
  DividerStopsCountersStyled,
} from "./styles";

export const getStopsField = (passedStops: number, totalStops: number) => {
  const zeroPassedStops = passedStops === 0;

  return (
    <TableFieldBodyStyled>
      <CounterBodyStyled>
        <LiveMissionsPolygonIcon />
        <CounterStopsStyled zeroCounter={zeroPassedStops}>
          {passedStops}
        </CounterStopsStyled>
      </CounterBodyStyled>
      <DividerStopsCountersStyled>Out of</DividerStopsCountersStyled>
      <CounterBodyStyled>
        <LiveMissionsPolygonIcon />
        <CounterStopsStyled>{totalStops}</CounterStopsStyled>
      </CounterBodyStyled>
    </TableFieldBodyStyled>
  );
};

export const getLoopsField = (passedLoops: number, totalLoops: number) => {
  const isInfinity = totalLoops === -1;
  const zeroPassedLoops = passedLoops === 0;

  return isInfinity ? (
    <CounterLoopsStyled zeroCounter={zeroPassedLoops} isInfinity={isInfinity}>
      {passedLoops}
    </CounterLoopsStyled>
  ) : (
    <TableFieldBodyStyled>
      <CounterLoopsStyled zeroCounter={zeroPassedLoops}>
        {passedLoops}
      </CounterLoopsStyled>
      <DividerLoopsCountersStyled>
        <RectangleIcon />
      </DividerLoopsCountersStyled>
      <CounterLoopsStyled>{totalLoops}</CounterLoopsStyled>
    </TableFieldBodyStyled>
  );
};
